import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/**  */
export const useFlagappReloadOnAuthTimeout = (): boolean => useINTERNALFlag('app-reload-on-auth-timeout');
/**  */
export const FlagappReloadOnAuthTimeout = (props: PropsNoName) => <INTERNALFlag name="app-reload-on-auth-timeout" {...props}/>
